import { Component } from "@angular/core";
import { NavController, NavParams, AlertController } from "ionic-angular";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { HomePage } from "../home/home";
import { IdolsListPage } from "../idols-list/idols-list";
import { ConfigService } from "../../services/config.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "page-pay-escrow",
  templateUrl: "pay-escrow.html",
})
export class PayEscrowPage {
  transaction: any;
  url: string;
  url_ok: string = "http://app.watafan.com/";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private iab: InAppBrowser,
    public alertCtrl: AlertController,
    private configService: ConfigService,
    private translateService: TranslateService
  ) {
    this.transaction = navParams.get("transaction");
    this.url = this.transaction.trustee_shortlink.short_url;
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad PagoInAppPage");
    this.executeInAppBrowser();
  }

  executeInAppBrowser() {
    var target = "_blank";
    var options = "location=yes";

    const browser = this.iab.create(this.url, target, options);
    browser.on("loadstart").subscribe((event) => {
      if (event.url.match(this.url_ok)) {
        console.log("event url match " + event.url);
        browser.close();
        this.messageAlert();
        this.navCtrl.setRoot(IdolsListPage);
      } else {
        console.log("event url " + event.url);
      }
    });
  }

  messageAlert() {
    var alert_message_title = this.translateService.instant(
      "pay_escrow.alert_message_title"
    );
    var accept = this.translateService.instant("home.alert_seeds_accept");

    let alert = this.alertCtrl.create({
      title: alert_message_title,
      //cssClass: "wallet-seeds-alert",
      buttons: [
        {
          text: accept,
          role: "cancel",
          handler: () => {
            console.log("Cancel clicked");
          },
        },
      ],
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/pay-escrow/pay-escrow.ts